import React from 'react';
import Img from 'gatsby-image';
import injectSheet from 'react-jss';

import Link from '../components/Link';

const valueOfRem = (str) => {
    return parseFloat(str.replace('rem', ''));
};

const Header = ({classes, menuTemplate, sizesLogo, sizesHamburger, menuExpanded, onToggleMenu}) => {
    const links = menuTemplate.map((link, index) => {
        return (
            <li key={index} className={classes.linkItem}>
                <Link
                    className={classes.link}
                    key={index}
                    to={link.to}>
                    {link.label}
                </Link>
            </li>
        );
    });
    
    return (
        <nav key="header" className={classes.container}>
            <Link to="/">
                <Img
                    outerWrapperClassName={classes.logo}
                    sizes={sizesLogo}
                    />
            </Link>
            <ul className={menuExpanded ?
                           `${classes.linkList} expanded` :
                classes.linkList}>
                {links}
            </ul>
            <div
                className={classes.hamburger}
                onClick={onToggleMenu}>
                <Img
                    outerWrapperClassName={classes.hamburgerIcon}
                    sizes={sizesHamburger}
                    />
            </div>
        </nav>
    );
};

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        zIndex: 10,
        width: '100%',
        backgroundColor: '#183C61',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
    },
    logo: {
        display: 'inline-block',
        width: ({ logoWidth }) => logoWidth,
        padding: '1.18rem 2.17rem'
    },
    linkList: {
        margin: '0.5em 0 0.5em auto',
        paddingRight: '2.17rem',
        display: 'flex',
        color: 'white'
    },
    linkItem: {
        listStyleType: 'none'
    },
    link: {
        fontFamily: [ 'Noto Sans Regular', 'sans-serif' ],
        fontSize: '0.88rem',
        color: 'white',
        margin: '0 1.12em',
        textTransform: 'uppercase',
        letterSpacing: '0.26em',
        textDecoration: 'none'
    },
    hamburger: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: ({ height = '4rem'}) => height,
        height: ({ height = '4.3rem'}) => height,
        display: 'none'
    },
    hamburgerIcon: {
        width: ({ hamburgerWidth }) => hamburgerWidth
    },
    dropdownItem: {
        listStyleType: 'none'
    },
    dropDownLink: {
        fontFamily: [ 'Noto Sans Regular', 'sans-serif' ],
        fontSize: '0.7rem',
        color: 'white',
        margin: '0 1em',
        padding: '0 1em',
        textTransform: 'uppercase',
        letterSpacing: '0.32em',
        textDecoration: 'none'
    },
    '@media only screen and (max-width: 1000px)': {
        container: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        },
        linkList: {
            display: 'none',
            width: '97%',
            margin: '1.5rem 0 0 0 ',
            flexDirection: 'column',
            alignItems: 'stretch',
            paddingLeft: 0,
            '&.expanded': {
                display: 'flex'
            }
        },
        linkItem: {
            padding: '1rem 2.17rem',
            boxShadow: '0 1px #999'
        },
        hamburger: {
            display: 'flex',
            alignItems: 'center'
        }
    }
};

export default injectSheet(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js